import { render, staticRenderFns } from "./CollapsibleFormGroup.vue?vue&type=template&id=9373f020&"
import script from "./CollapsibleFormGroup.vue?vue&type=script&lang=js&"
export * from "./CollapsibleFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports